









































import { Component, Vue, Prop } from "vue-property-decorator";
import ModalContentBox from "./Forms/ModalContentBox.vue";
import LessonContentCard from "./LessonContentCard.vue";
import { Label, Course } from "../store/store.types";
import { enToBnNum } from "../utils/common";
import ContentDeleteModal from "./Forms/ContentDeleteModal.vue";
import {
  ADMIN_LESSONS_ENDPOINT,
  ADMIN_EXAMS_ENDPOINT,
  ADMIN_COURSES_ENDPOINT,
} from "../store/endpoints";
import axios from "axios";
import { generateAuthHeader } from "../utils/auth";
import { Getter } from "vuex-class";
import { ACCESS_TOKEN } from "../store/getters.names";
import ExamContentCard from "./ExamContentCard.vue";
@Component({
  name: "uploadLessoncard",
  components: {
    ModalContentBox,
    "lesson-card": LessonContentCard,
    ContentDeleteModal,
    "exam-card": ExamContentCard,
  },
})
export default class UploadLessonCard extends Vue {
  showModal: boolean = false;
  removeModal: any = null;
  @Getter(ACCESS_TOKEN) accessToken: string | null;
  @Prop() course: Course;
  editData: any | null = null;

  editContent(content) {
    this.editData = content;
    this.showModal = true;
  }

  onModalClose() {
    this.showModal = false;
    this.editData = null;
    this.$emit("update");
  }

  contentRemoveHandler(d) {
    this.editData = null;
    this.showModal = false;
    this.removeModal = d;
  }

  handleContentRemove(e) {
    // console.log(e);
    let url = `${ADMIN_COURSES_ENDPOINT}${this.course.id}/contents/${this.removeModal.id}/`;
    // switch (this.removeModal.contentType) {
    //   case "lesson":
    //     url = `${ADMIN_COURSES_ENDPOINT}${this.course.id}/contents/${this.removeModal.id}/`;
    //     break;

    //   case "exam":
    //     url = `${ADMIN_EXAMS_ENDPOINT}${this.removeModal.id}/`;
    //     break;
    // }
    axios.delete(url, generateAuthHeader(this.accessToken)).then((resp) => {
      this.removeModal = null;
      this.showModal = false;
      this.$emit("update");
    });
  }

  get labels(): Label[] | null {
    let chapter_counter = 1;
    let exam_counter = 1;
    return this.course.contents.map((item, idx) => {
      if (item.content_type == "lesson") {
        const data = {
          en: `Lesson ${chapter_counter}`,
          bn: `পরিচ্ছেদ ${enToBnNum(chapter_counter)}`,
        };
        chapter_counter++;
        return data;
      } else {
        const data = {
          en: `Examination ${exam_counter}`,
          bn: `পরীক্ষা ${enToBnNum(exam_counter)}`,
        };
        exam_counter++;
        return data;
      }
    });
  }
}
